import { Box, Grid, Typography, LinearProgress } from "@mui/material";
import cargoSectionImage from "../../Assets/cargoTruck.jpg";
import { fontFamilyAll, secondaryColor } from "../../Util/UtilColor";
import { cargoDetailsData } from "../../Assets/data";

const CargoDetails = () => {
  const styles = {
    progressBar: {
      color: "white",
      fontSize: { xs: "14px", sm: "16px", md: "20px", lg: "22px" },
      fontWeight: 400,
      marginBottom: "8px",
      textAlign: "start",
    },
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        position: "relative",
        backgroundImage: `url(${cargoSectionImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: { xs: "70vh", sm: "75vh", md: "85vh" },
        alignContent: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.55)", // Overlay
          zIndex: 1,
        },
      }}
    >
      {/* Left Side Content */}
      <Grid
        item
        xs={12}
        md={5}
        sx={{ zIndex: 2, display: "flex", alignItems: "center" }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "480px" },
            mx: "auto",
            px: { xs: 2, sm: 4, md: 5 },
            py: { xs: 3, sm: 4, md: 5 },
            textAlign: { xs: "center", md: "right" },
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: { xs: "18px", sm: "22px", md: "26px" },
              fontWeight: 400,
            }}
            fontFamily={fontFamilyAll}
            textAlign={"left"}
          >
            {cargoDetailsData.heading}
          </Typography>

          <Typography
            sx={{
              color: "white",
              fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" },
              mt: 2,
              lineHeight: 1.6,
            }}
            fontFamily={fontFamilyAll}
            textAlign={"justify"}
          >
            {cargoDetailsData.description}
          </Typography>
        </Box>
      </Grid>

      {/* Right Side Progress Bars */}
      <Grid
        item
        xs={12}
        md={7}
        sx={{ zIndex: 2, display: "flex", alignItems: "center" }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "550px" },
            mx: "auto",
            px: { xs: 2, sm: 4, md: 5 },
            py: { xs: 3, sm: 4, md: 5 },
          }}
        >
          {cargoDetailsData.progress.map((item, idx) => (
            <Box key={idx} sx={{ mb: { xs: 2.5, sm: 3 } }}>
              <Typography sx={styles.progressBar} fontFamily={fontFamilyAll}>
                {item.label}{" "}
                <span style={{ color: "white", fontWeight: "600" }}>
                  {item.value}%
                </span>
              </Typography>
              <LinearProgress
                variant="determinate"
                value={item.value}
                sx={{
                  height: { xs: "12px", sm: "18px", md: "22px", lg: "28px" },
                  borderRadius: "6px",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: secondaryColor,
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CargoDetails;
